import { internalLogger } from '../../../interface/v1/clientOsLogger';
import { SetServiceDependencies } from '../../../infra/startup/types';
import { IEventService } from '../../eventService';
import { IConsentStrategy, ConsentUpdateEventData } from './IConsentStrategy';

/**
 * Event channels for consent-related events
 */
export const EVENT_CHANNELS = {
  CONSENT_UPDATED: 'consent.updated'
} as const;

/**
 * Abstract base class for consent strategies
 * Provides common functionality shared between Web and Native strategies
 */
export abstract class BaseConsentStrategy implements IConsentStrategy {
  protected _eventService: IEventService;

  /**
   * Event handler for consent updates - shared implementation
   * Broadcasts consent update events through EventService
   */
  public async onConsentUpdated?(
    eventData: ConsentUpdateEventData
  ): Promise<void> {
    try {
      // Broadcast consent updated event to other services
      await this._eventService.publish(EVENT_CHANNELS.CONSENT_UPDATED, {
        eventData: eventData
      });

      internalLogger?.debug?.(`Consent updated event published`, eventData);
    } catch (error) {
      internalLogger?.error(`Failed to publish consent event:`, error);
    }
  }

  // Abstract methods that must be implemented by concrete strategies
  public abstract init(): Promise<void>;
  public abstract setDependencies(dependencies: SetServiceDependencies): void;
  public abstract updateOptInGroupsInValueStore(): Promise<void>;
  public abstract refresh(): Promise<void>;
  public abstract isSupported(): boolean;
}
